import type { StaffRole } from './api/types';

export const ADMIN_TABS = ['overview', 'time-tracking', 'registries'] as const;

export const REGISTRY_VIEWS = [
  'staff',
  'clients',
  'task-types',
  'holidays',
  'attribution',
] as const;

export const REGISTRY_VIEW_LABELS: Record<(typeof REGISTRY_VIEWS)[number], string> = {
  staff: 'Staff',
  clients: 'Clients',
  'task-types': 'Task types',
  holidays: 'Holidays',
  attribution: 'Attribution',
};

export const UNASSIGNED_OWNER = 'unassigned';

export const ROLE_LABELS: Record<StaffRole, string> = { cfo: 'CFO', data_team: 'Data team' };

export const DIAGNOSTIC_STATUS_VARIANT: Record<
  string,
  'destructive' | 'warning' | 'success' | 'outline'
> = {
  unmapped: 'destructive',
  fuzzy: 'warning',
  slug: 'success',
  exact: 'success',
  tag: 'success',
  'non-csd': 'outline',
};
